import React from 'react';
import SheetHeader from './SheetHeader';
import { Slide } from 'components/animate';
import { Spacer, Card } from '@cleartrip/bento';
import IntLoading from 'pages/TravelSafe/IntLoading';
import { align, getArabicFontStyle } from 'helper/flyin';

function Sheet(props) {
	const { headerTitle, isShowing, onClose, children, loading,} = props;
	return (
		<Slide toggle={isShowing}>
			<Card style={{ height: '100vh',...getArabicFontStyle() }} className='w-100p l-0 bg-white z-20 d-none d-block--xs'>
				<SheetHeader align={align} loading={loading} title={headerTitle} onClose={onClose} />
				<Spacer className='pt-13' />
				<div className='oy-auto' style={{ height: `calc(100vh - 52px)`, direction:align()}}>
					{loading ? (
						<>
							<Spacer className='pt-10' /> <IntLoading />
						</>
					) : (
						children
					)}
				</div>
			</Card>
		</Slide>
	);
}

export default Sheet;
